import { Flex } from 'antd';
import { SkeletonLine, SkeletonTextLine } from '../common/skeleton/skeletonLine';
import { PeriodDivider, PeriodSummary } from './preliminaryInvoiceCreation.styled';

const LabelSkeleton = ({ width, lineheight = '18px' }: { width: string; lineheight?: string }) => (
  <SkeletonTextLine $lineheight={lineheight}>
    <SkeletonLine $width={width} $height="10px" />
  </SkeletonTextLine>
);

/** Same height as the large primary button that ends both forms. */
const SubmitButtonSkeleton = () => (
  <SkeletonLine data-testid="skeleton-submit-button" $height="36px" $radius="5px" />
);

const FieldSkeleton = ({ labelWidth }: { labelWidth: string }) => (
  <Flex vertical gap={5} data-testid="skeleton-form-field">
    {/* antd sets a vertical form label in a 22px line box */}
    <LabelSkeleton width={labelWidth} lineheight="22px" />
    <SkeletonLine $height="44px" $radius="5px" />
  </Flex>
);

export const PreliminaryInvoicePeriodicalSkeleton = () => (
  <Flex vertical gap="var(--spacing-gutter)" data-testid="preliminary-invoice-periodical-skeleton">
    <PeriodSummary vertical gap="var(--spacing-gutter)">
      <Flex justify="space-between" align="center">
        <LabelSkeleton width="70px" />
        <SkeletonLine $width="80px" $height="23px" $radius="30px" />
      </Flex>
      <PeriodDivider />
      <Flex vertical gap={5}>
        <LabelSkeleton width="95px" />
        <SkeletonTextLine $lineheight="28px">
          <SkeletonLine $width="170px" $height="16px" />
        </SkeletonTextLine>
      </Flex>
    </PeriodSummary>
    <SubmitButtonSkeleton />
  </Flex>
);

export const PreliminaryInvoiceUntilDateSkeleton = () => (
  <Flex vertical gap="var(--spacing-gutter)" data-testid="preliminary-invoice-until-date-skeleton">
    <FieldSkeleton labelWidth="95px" />
    <FieldSkeleton labelWidth="65px" />
    <SubmitButtonSkeleton />
  </Flex>
);
